export const Messages = {
  REGISTRATION: 'Registration successful.',
  SIGNUP_SUCCESS: 'You will receive an acknowledgement mail shortly. ',
  INVALID_ORG: 'Invaild Organisation',
  UNSAVED_CHANGES: 'You may have unsaved changes. Are you sure you want to leave?',
  VALID_MIN_MAX: 'Please enter a valid min/max range',
  DELETE_PLANT: 'Are you sure want to remove the plant?',
  REMOVE_CONFIG: 'Are you sure want to remove Configuration?',
  DELETE_SUCCESS: 'Deleted Successfully',
  DELETE_FAILED: 'Delete Operation Failed',
  TAB_SYSTEM: 'system',
  TAB_GLOBAL: 'global',
  TAB_TENANT: 'tenant',
  TAB_SITE: 'site',
  SUCCESS: 'success',
  ERROR: 'error',
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  CLONE: 'clone',
  RESTORE: 'Restore triggered',
  DOWNLOAD: 'download',
  STATS: 'stats',
  DELETE_ALERT: 'Are you sure want to delete alert Id: ',
  DELETE_RULE: 'Are you sure want to remove the Role?',
  DELETE_TRADE: 'Are you sure want to remove the Trade?',
  DELETE_FEATURE: 'Are you sure want to remove the Feature?',
  DELETE_OTA: 'Are you sure want to remove the Device app ota?',
  DELETE_ERRORCODE: 'Are you sure want to remove the Error Code?',
  DELETE_USER: 'All Plant, Zones, Supervisor and Device allocations will be removed for this user while delete, continue?',
  DELETE_CLIENT: 'Are you sure you want to delete the Tenant, Please note all the associated mappings also will be deleted on deleting the Tenant',
  IMAGE_DELETE: 'Image will be deleted permanently. Are you sure?',
  EDIT_USER: 'Do you want to save the changes?',
  ACCEPT_USER: 'Are you sure you want to approve the user?',
  REJECT_USER: 'Are you sure you want to reject the user?',
  REVOKE_PASSWORD: 'Are you sure you want to revoke password?',
  RESET_PASSWORD: 'Are you sure you want to reset password?',
  DEVICE_STATS_ALERT: 'Device stats information not available',
  DATERANGE_TODAY: 'Today',
  DATERANGE_YESTERDAY: 'Yesterday',
  DATERANGE_LAST_SEVEN_DAYS: 'Last 7 Days',
  DATERANGE_LAST_THIRTY_DAYS: 'Last 30 Days',
  DATERANGE_THIS_MONTH: 'This Month',
  DATERANGE_LAST_MONTH: 'Last Month',
  DATERANGE_LAST_THREE_MONTH: 'Last 3 Month',

  //Template Creation form
  TEMPLATE_FORM_TEMPLATE_NAME_LABEL: 'Template Name',
  TEMPLATE_FORM_TEMPLATE_ID_LABEL: 'Template Id', 
  TEMPLATE_FORM_TENANT_NAME_LABEL: 'Tenant Name',
  TEMPLATE_FORM_DESCRIPTION_LABEL: 'Description',
  MESSAGE_REQUIRED: ' is required',
  TEMPLATE_FORM_PAYLOAD_TYPE_LABEL: 'Payload Type',
  TEMPLATE_FORM_NAME_LABEL: 'Name',
  TEMPLATE_FORM_TYPE_LABEL: 'Select Type',
  TEMPLATE_FORM_TIME_ZONE_LABEL: 'Time Zone',
  TEMPLATE_FORM_FORMAT_LABEL: 'Format',
  TEMPLATE_FORM_FIELD_TO_CHANGE_LABEL: 'Field To Change',
  TEMPLATE_FORM_SELECT_HEADER_LABEL: 'Select Header',
  TEMPLATE_FORM_TREND_SLOPE_LABEL: 'Trend Slope',
  TEMPLATE_FORM_SEASONALITY_AMPLITUDE_LABEL: 'Seasonality Amplitude',
  TEMPLATE_FORM_INITIAL_VALUE_LABEL: 'Initial Value',
  TEMPLATE_FORM_NOISE_LEVEL_LABEL: 'Noise Level',
  TEMPLATE_FORM_TREND_NOISE_LEVEL_LABEL: 'Trend Noise Level',
  TEMPLATE_FORM_LOWER_THRESHOLD_LABEL: 'Lower Threshold',
  TEMPLATE_FORM_UPPER_THRESHOLD_LABEL: 'Upper Threshold',
  TEMPLATE_FORM_NO_OF_DECIMALS_LABEL: 'No of Decimals',
  TEMPLATE_FORM_START_VALUE_LABEL: 'Start Value',
  TEMPLATE_FORM_END_VALUE_LABEL: 'End Value',
  TEMPLATE_FORM_STEP_VALUE_LABEL: 'Step Value',
  TEMPLATE_FORM_INPUT_VALUE_LABEL: 'Input Value',
  TEMPLATE_FORM_BEHAVIOUR_AFTER_LAST_VALUE_LABEL: 'Behaviour After Last Value',
  TEMPLATE_FORM_CUMULATIVE_LABEL: 'Cumulative',
  TEMPLATE_FORM_CARRY_FORWARD_LABEL: 'Carry Forward',
  TEMPLATE_FORM_FIELD_LENGTH_LABEL: 'Field Length',

  //Batch Creation Form
  BATCH_FORM_HEADING: 'Select Batch Details',
  BATCH_FORM_BATCH_ID: 'Batch Id',
  BATCH_FORM_START_TIME: 'Start Time',
  BATCH_FORM_NOTE_TEXT: 'Note: For immediate execution, set start time 5 mins greater than current time.',
  BATCH_FORM_END_TIME: 'End Time',
  BATCH_FORM_SCHEDULED_FROM: 'Scheduled From',
  BATCH_FORM_SCHEDULED_TO: 'Scheduled To',
  BATCH_FORM_REPORTING_INTERVAL_IN_MS: 'Reporting Interval In Ms',
  BATCH_FORM_MIN_REPORTING_INTERVAL_IN_MS: 'Minimum Reporting Interval In Ms',
  BATCH_FORM_MAX_REPORTING_INTERVAL_IN_MS: 'Maximum Reporting Interval In Ms',
  BATCH_FORM_SAMPLING_INTERVAL_IN_MS: 'Sampling Interval In Ms',
  BATCH_FORM_SAMPLING_CHECKBOX_LABEL: 'Same as Reporting Interval',
  BATCH_FORM_SAMPLING_ERROR_MESSAGE: 'Minimum value is 100',
  BATCH_FORM_MAX_REPORTING_INTERVAL_ERROR_MESSAGE: 'Maximum value cannot exceed the start and end time difference.',
  BATCH_FORM_MAX_REPORTING_INTERVAL_LESS_THAN_MIN_ERROR_MESSAGE: 'Maximum value should be greater than minimum.',
  BATCH_FORM_MISSING_DATA_MIN_ERROR_MESSAGE: 'Minimum value is 1',
  BATCH_FORM_MISSING_DATA_MAX_ERROR_MESSAGE: 'Maximum value is 99',
  BATCH_FORM_MULTIPLE_REPORTING_INTERVAL_LABEL: 'Random Reporting Interval',
  BATCH_FORM_MISSING_DATA_LABEL: 'Missing Data Simulation',
  BATCH_FORM_MISSING_DATA_PERCENTAGE_LABEL: 'Percentage',
  BATCH_FORM_LATE_PACKET_DATA_LABEL: 'Late Data Packet Simulation',
  BATCH_FORM_TEMPLATE: 'Template',
  BATCH_FORM_INSTANCE_ID: 'Instance Id',
  BATCH_FORM_END_POINT_TYPE: 'End Point Type',
  BATCH_FORM_END_POINT_ID: 'End Point Id',
  BATCH_FORM_UPLOAD_DATASET: 'Upload Dataset',
  BATCH_FORM_FILE_TYPE_ERROR_MESSAGE: 'Supported File Type is csv.',
  BATCH_FORM_FILE_SIZE_ERROR_MESSAGE: 'Maximum size for file is 100 MB.',
  BATCH_FORM_SCHEDULE_STATUS: 'Schedule Status',
  BATCH_FORM_RESET_BUTTON_LABEL: 'Reset',
  BATCH_FORM_SUBMIT_BUTTON_LABEL: 'Submit',
  BATCH_FORM_CANCEL_BUTTON_LABEL: 'Cancel',
  BATCH_FORM_UPDATE_BUTTON_LABEL: 'Update'
};
